<template>
  <v-menu v-model="menu" open-on-hover>
    <template v-slot:activator="{ on, attrs }">
      <v-autocomplete
        color="primary"
        hide-no-data
        v-model="qacenterSelected"
        :clearable="!unclearable"
        :items="qacentersSelected"
        :loading="loading"
        :search-input.sync="qacenterSearch"
        item-text="name"
        item-value="id"
        :label="label"
        return-object
        v-bind="attrs"
        v-on="on"
        :error-messages="errorMessages"
      >
        <template v-slot:append>
          <v-icon
            style="height: 24px; width: 24px"
            :color="menu ? 'primary' : ''"
            @click.stop="menu = !menu"
          >
            {{ menu ? "fa-caret-up" : "fa-caret-down" }}
          </v-icon>
        </template>
      </v-autocomplete>
    </template>
    <div style="max-height: 304px">
      <v-sheet>
        <v-treeview
          v-model="tree"
          :items="notice ? notice : qacenter_categories"
          :search="qacenterSearch"
          :filter="qacenterFilter"
          :active.sync="qacentersSelected"
          item-key="id"
          item-children="categories"
          open-all
          hoverable
          activatable
          return-object
        />
      </v-sheet>
    </div>
  </v-menu>
</template>

<style scoped>
.v-list {
  display: none !important;
}
.v-menu__content {
  margin-top: 34px;
}
</style>

<script>
import QacenterCategory from "@/api/qacenter";

export default {
  name: "SearcherQacenterCategory",
  props: {
    value: Object,
    label: String,
    noLabel: Boolean,
    unclearable: Boolean,
    errorMessages: Array,
    notice: Array,
    categrayRefresh: Boolean,
  },

  computed: {
    qacenterFilter() {
      return (item, search, textKey) =>
        this.qacenterSelected && search == this.qacenterSelected.name
          ? true
          : item[textKey].indexOf(search) > -1;
    },
  },

  data: () => ({
    menu: false,
    tree: [],
    qacenter_categories: [],
    loading: false,
    qacenterSearch: "",
    qacentersSelected: [],
    qacenterSelected: null,
  }),

  methods: {
    getDistrictsFromAPI() {
      this.loading = true;
      QacenterCategory.tree()
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.qacenter_categories = response.data.qacenter_categories;
            }
            this.loading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.loading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    notice: {
      immediate: true,
      handler() {
        if (!this.notice) {
          this.getDistrictsFromAPI();
        }
      },
    },
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.qacentersSelected = this.value ? [this.value] : [];
      },
    },
    qacentersSelected: {
      immediate: true, //初始赋值也调用
      handler() {
        this.qacenterSelected =
          this.qacentersSelected && this.qacentersSelected[0]
            ? this.qacentersSelected[0]
            : null;
      },
    },
    qacenterSelected: {
      handler() {
        this.qacentersSelected = this.qacenterSelected
          ? [this.qacenterSelected]
          : [];
        this.$emit("input", this.qacenterSelected);
      },
    },
    qacenterSearch: {
      handler() {
        if (!this.unclearable && !this.qacenterSearch)
          this.qacentersSelected = [];
      },
    },
    categrayRefresh: {
      deep: true,
      handler() {
        this.getDistrictsFromAPI();
      },
    },
  },
};
</script>
